<template>
    <b-card header="Email"
        header-bg-variant="info"
        header-text-variant="white"
        >
        <form @submit.prevent="saveEmail()">
            <b-row>
                <b-col lg="6" xs="12">
                    <b-form-group label="Email Address" label-for="current">
                        <b-form-input
                                id="current"
                                name="current"
                                type="email"
                                v-model="user.email"
                                disabled
                        >
                        </b-form-input>
                    </b-form-group>
                </b-col>
            </b-row>
        </form>
    </b-card>
</template>

<script>
    export default {
        props: {
            'user': {}
        },

        data() {
            return {}
        },

        mounted() {
        },

        methods: {
            saveEmail() {},
        },
    }
</script>
